module.exports = __webpack_public_path__ + "img/SD.8f0ac64a.svg";